import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { SwitchTransition, CSSTransition } from "react-transition-group";

import { Header, ModalHeader, Grid, Icon, Progress, Modal } from 'semantic-ui-react'
import { RadioGroup } from '../RadioGroup'
import { Wrapper, Content, Footer } from '../Modal/style'
import { ModalWrapper, ThemedText, CustomPopup, ThemedLink, ProjectImage, AnyQuestions, DoubleIcon, LastPageButtons } from './style'
import { MainButton, SecondaryButton, ProjectsIcon } from '../../pages/main_page/components/style'
import { FlexBlock } from '@/components/OtherCustomComponents/style'
import { themes } from '@/theme/context'

let isWizardShow = false //если модальное окно откроется раньше инициализации jivo

global.jivo_onLoadCallback = function() {
    if (isWizardShow) {
        const jivoMobileButton: any = document.querySelector('jdiv.__jivoMobileButton')
        jivoMobileButton.style.zIndex = '1'
    }
}
const ProjectIcon = ({ href, act }) => (
    <ProjectsIcon $color={themes[act].primaryColor} className='hiddenMobile'>
        <a href={href}>
            <ProjectImage src={`/themes/defaultNiimko/images/new/icons/${act}.svg`} />
        </a>
    </ProjectsIcon>
)

export const Wizard = ({ showWizard, drupalHost, currentAct }) => {
    const nodeRef = React.useRef<any>(null);
    const { primaryColor } = themes[currentAct];
    const dispatch = useDispatch<any>();
    const [selected, setSelected] = React.useState<any>([])
    const [tempSelected, setTempSelected] = React.useState<any>()
    const [page, setPage] = React.useState<any>({ state : 0})

    const activeForm = page.state
    const prevForm = page.prevState

    useEffect(() => {
        if (showWizard || !global.location.search.includes('wizard')) return;

        dispatch({ type: 'TOGGLE_WIZARD' })
        //удаляю "?wizard" из адресной строки
        global.history.pushState("", document.title, global.location.pathname);
    }, [])

    //скрываем кнопку jivo
    useEffect(() => {
        isWizardShow = showWizard
        const jivoMobileButton:any = document.querySelector('jdiv.__jivoMobileButton')
        if (jivoMobileButton)
            jivoMobileButton.style.zIndex = showWizard ? '1' : '2147483647'

        //сброс при повторном открытии
        setSelected([])
        setPage({ state: 0 })
        setTempSelected(undefined)
        showWizard && global.ym && global.ym(4897120, 'reachGoal', 'open_wizard')
    }, [showWizard]);

    const changeActiveForm = (state) =>{
        setPage((prevState) => {
            return { prevState: prevState.state, state}
        })
    }

    const questions = [
        {
            question: 'К какой категории Вы относитесь?',
            answers: [
                'Организатор в вузе',
                'Организатор в ссузе',
                'Студент'
            ]
        },
        {
            question: 'Кого планируете протестировать?',
            answers: [
                'первокурсников, обучающихся в первом семестре',
                'первокурсников, обучающихся во втором семестре',
                'студентов 2-3 курсов',
                'выпускников'
            ]
        },
        {
            question: 'Необходимо ли образовательной организации подтверждение успешных результатов студентов по направлению подготовки в форме сертификата качества?',
            answers: [
                'Да, обязательно! И педагогический анализ',
                'Нет, достаточно рейтинг-листов',
            ]
        },
        {
            question: 'На каком курсе Вы обучаетесь?',
            answers: [
                'На первом',
                'На втором',
                'На третьем',
                'На четвертом',
                'На пятом',
            ]
        },
        {
            question: 'Для чего Вам необходимо пройти тестирование?',
            answers: [
                'Мне нужно подготовиться к тестированию, запланированному преподавателем',
                'Мне нужно подготовиться к экзамену для выпускников',
                'Хочу сдать экзамен для выпускников вуза и получить сертификат',
                'Планирую принять участие в олимпиаде',
            ]
        }
    ]


    const orgAnswers = {
        11: <>
            <FlexBlock>
                <ProjectIcon act="diag" href={`//diag.${drupalHost}`} />
                <span>Для оценки знаний и готовности первокурсников к обучению используйте <ThemedLink $color={themes.diag.primaryColor} href={`//diag.${drupalHost}`}>Диагностическое интернет-тестирование студентов первого курса</ThemedLink>.</span>
            </FlexBlock>
        </>,
        12: <>
            <FlexBlock>
                <ProjectIcon act="fepo" href={`//fepo.${drupalHost}`} />
                <span>Рекомендуем Вам подать заявку на участие в <ThemedLink $color={themes.fepo.primaryColor} href={`//fepo.${drupalHost}`}>Федеральном интернет-экзамене в сфере профессионального образования (ФЭПО)</ThemedLink>. Он соответствует всем заявленным критериям и позволит образовательной организации получить сертификат качества.</span>
            </FlexBlock>
            <FlexBlock>
                <ProjectIcon act="ias" href={`//training.${drupalHost}`} />
                <span>Чтобы подготовить студентов к предстоящему экзамену, дополнительно подключитесь к сервису <ThemedLink $color={themes.ias.primaryColor} href={`//training.${drupalHost}`}>«Интернет-тренажеры в сфере образования»</ThemedLink>.</span>
            </FlexBlock>
        </>,
        131: <>
            <FlexBlock>
                <ProjectIcon act="fepo" href={`//fepo.${drupalHost}`} />
                <span>В качестве инструмента оценки уровня подготовки студентов 2-3 курсов используйте <ThemedLink $color={themes.fepo.primaryColor} href={`//fepo.${drupalHost}`}>Федеральный интернет-экзамен в сфере профессионального образования (ФЭПО)</ThemedLink>.</span>
            </FlexBlock>
            <FlexBlock>
                <ProjectIcon act="fepo_pro" href={`//fepo.${drupalHost}/fepo_pro`} />
                <span>На экваторе обучения, по завершении студентами 2-го курса есть возможность провести сертификационный экзамен <ThemedLink $color={themes.fepo_pro.primaryColor} href={`//fepo.${drupalHost}/fepo_pro`}>ФЭПО-pro</ThemedLink>.</span>
            </FlexBlock>
        </>,
        132: <>
            <FlexBlock>
                <ProjectIcon act="ias" href={`//training.${drupalHost}`} />
                <span>Оценить целостность и прочность усвоения студентами материала, провести промежуточный контроль знаний, в том числе по самостоятельно разработанным тестовым заданиям можно с помощью сервиса <ThemedLink $color={themes.ias.primaryColor} href={`//training.${drupalHost}`}>«Интернет-тренажеры в сфере образования»</ThemedLink>.</span>
            </FlexBlock>
        </>,
        141: <>
            <FlexBlock>
                <ProjectIcon act="fieb" href={`//bakalavr.${drupalHost}`} />
                <span>Получить внешнюю объективную оценку уровня подготовки ваших выпускников можно с помощью <ThemedLink $color={themes.fieb.primaryColor} href={`//bakalavr.${drupalHost}`}>Федерального интернет-экзамена для выпускников бакалавриата и специалитета (ФИЭБ)</ThemedLink>. Успешные результаты студентов позволят получить вузу сертификат качества по направлению подготовки.</span>
            </FlexBlock>
            <FlexBlock>
                <ProjectIcon act="tfieb" href={`//tfieb.${drupalHost}`} />
                <span>Чтобы подготовить студентов к предстоящему экзамену, дополнительно подключитесь к сервису <ThemedLink $color={themes.tfieb.primaryColor} href={`//tfieb.${drupalHost}`}>«Тренажер ФИЭБ»</ThemedLink>.</span>
            </FlexBlock>
        </>,
        142: <>
            <FlexBlock>
                <ProjectIcon act="tfieb" href={`//tfieb.${drupalHost}`} />
                <span>Проведите внутренний интернет-экзамен для выпускников без видеонаблюдения и трансляции с помощью <ThemedLink $color={themes.tfieb.primaryColor} href={`//tfieb.${drupalHost}`}>Тренажера ФИЭБ</ThemedLink>. Результаты будут представлены в форме рейтинг-листов.</span>
            </FlexBlock>
        </>
    }

    orgAnswers[21] = orgAnswers[11]
    orgAnswers[22] = orgAnswers[231] = orgAnswers[241] = orgAnswers[12]
    orgAnswers[232] = orgAnswers[242] = orgAnswers[132]

    const studAnswer = [
        <>
            <FlexBlock>
                <ProjectIcon act="ias" href={`//training.${drupalHost}`} />
                <span>Для подготовки к тестированию советуем использовать <ThemedLink $color={themes.ias.primaryColor} href={`//training.${drupalHost}`}>«Интернет-тренажеры в сфере образования»</ThemedLink>. Доступ к сервису можно приобрести самостоятельно. Для этого просто зарегистрируйте личный кабинет.</span>
            </FlexBlock>
            <FlexBlock>
                <DoubleIcon>
                    <ProjectIcon act="fieb" href={`//bakalavr.${drupalHost}`} />
                    <ProjectIcon act="olymp" href={`//olymp.${drupalHost}`} />
                </DoubleIcon>
                <span>Там же в дальнейшем Вы сможете зарегистрироваться для участия в <ThemedLink $color={themes.fieb.primaryColor} href={`//bakalavr.${drupalHost}`}>Федеральном интернет-экзамене для выпускников бакалавриата и специалитета (ФИЭБ)</ThemedLink> и <ThemedLink $color={themes.olymp.primaryColor} href={`//olymp.${drupalHost}`}>Интернет-олимпиадах</ThemedLink>.</span>
            </FlexBlock>
        </>,
        <>
            <FlexBlock>
                <ProjectIcon act="tfieb" href={`//tfieb.${drupalHost}`} />
                <span>Подготовиться к Федеральному интернет-экзамену для выпускников бакалавриата и специалитета (ФИЭБ) Вам поможет <ThemedLink $color={themes.tfieb.primaryColor} href={`//tfieb.${drupalHost}`}>Тренажер ФИЭБ</ThemedLink>. Доступ к нему можно приобрести в личном кабинете.</span>
            </FlexBlock>
        </>,
        <>
            <FlexBlock>
                <ProjectIcon act="fieb" href={`//bakalavr.${drupalHost}`} />
                <span>Будем рады видеть Вас в числе участников <ThemedLink $color={themes.fieb.primaryColor} href={`//bakalavr.${drupalHost}`}>Федерального интернет-экзамена для выпускников бакалавриата и специалитета (ФИЭБ)</ThemedLink>. Для этого просто зарегистрируйте <a href={`//auth.${drupalHost}/signup`}>личный кабинет</a>.</span>
            </FlexBlock>
            <FlexBlock>

                <ProjectIcon act="tfieb" href={`//tfieb.${drupalHost}`} />
                <span>Чтобы подготовиться к экзамену, Вы можете дополнительно приобрести доступ к <ThemedLink $color={themes.tfieb.primaryColor} href={`//tfieb.${drupalHost}`}>Тренажеру ФИЭБ</ThemedLink>.</span>
            </FlexBlock>
        </>,
        <>
            <FlexBlock>
                <ProjectIcon act="olymp" href={`//olymp.${drupalHost}`} />
                <span>Смело переходите в раздел «Олимпиады» и регистрируйте личный кабинет для самостоятельного участия в <ThemedLink $color={themes.olymp.primaryColor} href={`//olymp.${drupalHost}`}>Интернет-олимпиадах</ThemedLink>.</span>
            </FlexBlock>
            <FlexBlock>
                <ProjectIcon act="fieb" href={`//bakalavr.${drupalHost}`} />
                <span>В дальнейшем через личный кабинет Вы сможете зарегистрироваться для участия в <ThemedLink $color={themes.fieb.primaryColor} href={`//bakalavr.${drupalHost}`}>Федеральном интернет-экзамене для выпускников бакалавриата и специалитета (ФИЭБ)</ThemedLink>.</span>
            </FlexBlock>
        </>,
    ]

    //олимпиады для организаторов вузов/ссузов
    const orgAnswersExtra = {
        //[11, 12, 132]
        11: <>
            <FlexBlock>
                <ProjectIcon act="olymp" href={`//olymp.${drupalHost}/node/2874`} />
                <span>Оценить потенциал и выявить талантливых, одаренных студентов, повысив престиж вуза, помогут <ThemedLink $color={themes.olymp.primaryColor} href={`//olymp.${drupalHost}/node/2874`}>Открытые международные студенческие интернет-олимпиады</ThemedLink>.</span>
            </FlexBlock>
        </>,
        //[21, 22, 232]
        21: <>
            <FlexBlock>
                <ProjectIcon act="olymp" href={`//olymp.${drupalHost}/node/2876`} />
                <span>Оценить потенциал и выявить талантливых, одаренных студентов помогут <ThemedLink $color={themes.olymp.primaryColor} href={`//olymp.${drupalHost}/node/2876`}>Открытые международные студенческие интернет-олимпиады</ThemedLink>.</span>
            </FlexBlock>
        </>
    }
    orgAnswersExtra[12] = orgAnswersExtra[132] = orgAnswersExtra[11]
    orgAnswersExtra[22] = orgAnswersExtra[232] = orgAnswersExtra[21]

    let activeQestion = questions[0]

    if (activeForm == 1) {
        if (['1', '2'].includes(selected[0])) {
            activeQestion = questions[1]
        } else {
            activeQestion = questions[3]
        }
    }

    if (activeForm == 2) {
        if (['1', '2'].includes(selected[0])) {
            activeQestion = questions[2]
        } else {
            activeQestion = questions[4]
        }
    }

    const showNextButton = activeForm < 3 && (!orgAnswers[selected.join('')] || selected.length != activeForm)

    return (
        <ModalWrapper
            open={showWizard}
            onClose={() => dispatch({ type: 'TOGGLE_WIZARD' })}
            dimmer={{
                style: {
                    backgroundColor: 'rgba(0, 0, 0, .3)'
                }
            }}
        >
                <ModalHeader>
                    <Header>Помощник в выборе сервиса</Header>
                    <Icon link name='close' onClick={() => dispatch({ type: 'TOGGLE_WIZARD' })} />
                </ModalHeader>
                <Content className='content'>
                    <SwitchTransition mode="out-in">
                        <CSSTransition
                            key={activeForm}
                            nodeRef={nodeRef}
                            timeout={300}
                            unmountOnExit
                            className={activeForm < prevForm ? 'revert' : ''}
                            classNames='answers'
                        >
                            <div ref={nodeRef}>
                                {selected[0] === '3' && activeForm == 3 ?
                                    <div>
                                        {studAnswer[selected[2] - 1]}
                                        <br/>
                                        <ThemedText $color={primaryColor}><b><i>Желаем успехов!</i></b></ThemedText>
                                    </div>
                                : orgAnswers[selected.join('')] && selected.length == activeForm ?
                                    <div>
                                        {orgAnswers[selected.join('')]}
                                        {orgAnswersExtra[selected.join('')]}
                                        <br/>
                                        <ThemedText $color={primaryColor}><b><i>Будем рады видеть Вашу образовательную организацию в числе пользователей сервисов экосистемы независимой оценки в образовании!</i></b></ThemedText>
                                    </div>
                                :
                                    <RadioGroup
                                        key={activeForm}
                                        header={activeQestion?.question || ''}
                                        fields={activeQestion?.answers.map((item, i) => ({ name: item, value: i + 1 + '' })) || []}
                                        checked={tempSelected}
                                        onChange={i => {
                                            let tempSelectedTemp = selected.slice(0, activeForm)
                                            tempSelectedTemp.push(i)
                                            setTempSelected(i)
                                        }}
                                    />
                                }
                            </div>
                        </CSSTransition>
                    </SwitchTransition>
                    <Progress indicating percent={+(!showNextButton ? 100 : activeForm ? 100 * (activeForm / 3) : 0)} size="tiny" autoSuccess />
                </Content>
                <Footer>
                    {activeForm > 0 &&
                        <MainButton
                            onClick={() => {
                                !nodeRef.current.classList.contains('revert') &&
                                nodeRef.current.classList.add('revert')

                                setTempSelected(selected[activeForm - 1])
                                changeActiveForm(activeForm - 1)
                            }}
                            primary
                            $color={primaryColor}
                            floated='left'
                        >Назад</MainButton>
                    }
                    {showNextButton ?
                        <MainButton
                            onClick={() => {
                                if (typeof tempSelected === 'undefined') return

                                let tempSelectedTemp = selected.slice(0, activeForm)
                                tempSelectedTemp.push(tempSelected)

                                nodeRef.current.classList.remove('revert')
                                setSelected(tempSelectedTemp)
                                setTempSelected(undefined)
                                changeActiveForm(activeForm + 1)
                                if (tempSelectedTemp[0] == '3' && activeForm == 1) {
                                    global.ym && global.ym(4897120, 'reachGoal', 'student_' + tempSelectedTemp[1])
                                }
                            }}
                            primary
                            $color={primaryColor}
                            disabled={typeof tempSelected === 'undefined'}
                        >Далее</MainButton>
                    :
                        <LastPageButtons>
                            <CustomPopup
                                content={
                                    <Grid>
                                        <Grid.Row>
                                            <Grid.Column width={5}>
                                                телефон:
                                            </Grid.Column>
                                            <Grid.Column width={11}>
                                                <ThemedLink $color={primaryColor} href="tel:+78362641688">+7&nbsp;8362&nbsp;64-16-88</ThemedLink><br />
                                                <span className='description'>пн.-пт. 8:30–17:30 (MSK)</span>
                                            </Grid.Column>
                                        </Grid.Row>
                                        <Grid.Row>
                                            <Grid.Column width={5}>
                                                email:
                                            </Grid.Column>
                                            <Grid.Column width={11}>
                                                <ThemedLink $color={primaryColor} href="mailto:nii.mko@yandex.ru">nii.mko@yandex.ru</ThemedLink>
                                            </Grid.Column>
                                        </Grid.Row>
                                    </Grid>
                                }
                                trigger={<AnyQuestions $color={primaryColor}>Остались вопросы?</AnyQuestions>}
                                size="huge"
                                style={{ fontSize: '18px' }}
                                hoverable={true}
                                mouseLeaveDelay={500}
                                on='click'
                                wide={true}
                            />
                            <SecondaryButton
                                href={`//auth.${drupalHost}/signup`}
                                basic
                                $color={primaryColor}
                            >Зарегистрироваться</SecondaryButton>
                        </LastPageButtons>
                    }
                </Footer>
        </ModalWrapper>
    )
}
